import { isUserLogin } from '@eureka/utils/account';
import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface AgentAuthCheckRequest {
    id: string;
}

export interface AgentAuthCheckResponse {
    has_permission: boolean;
}

export interface AgentAuthApi {
    checkDocumentAnalyzerAuth(data: AgentAuthCheckRequest): Promise<boolean>;
}

export const AgentAuthApi = Symbol('AgentAuthApi');

@injectable()
export class AgentAuthApiImpl extends PsHttpService implements AgentAuthApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async checkDocumentAnalyzerAuth(data: AgentAuthCheckRequest) {
        const isLogin = await isUserLogin()
        return this.get<PatSnapCommonResponseData<boolean>>({
            url: isLogin ? `file/group/check/${data.id}` : `guest/file/group/check/${data.id}`,
        }).then((res) => {
            return res as unknown as boolean;
        });
    }
}
